import React from 'react';
import 'bootstrap/dist/css/bootstrap.css'; // Importa los estilos de Bootstrap
import { Image, Button } from 'react-bootstrap'; // Importa el componente de botón de Bootstrap



function Proximamente() {

  const logo  = 'images/logo.png';
  const wsp  = 'images/WSP.png';
  const fb  = 'images/FB.png';
  const tel  = 'images/tel.png';
  const inst  = 'images/INST.png';

  const phoneNumber = '8121082008'; // Número de WhatsApp
  const phoneNumber2 = '+528182188555'; // Número de WhatsApp

  const openWhatsApp = () => {
    window.open(`https://wa.me/${phoneNumber}`, '_blank');
  };

  const openAviso = () => {
    window.open(`https://oncare.com.mx/aviso_privacidad.html`, '_blank');
  };


  const openTel = () => {
    window.open(`tel:${phoneNumber2}`, '_blank');
  };



  const openInsta = () => {
    window.open(`https://www.instagram.com/oncaremx/`, '_blank');
  };
  const openFB = () => {
    window.open(`https://www.facebook.com/OncareTreatmentCenter`, '_blank');
  };
  return (
    <div className="container-fluid vh-100 d-flex flex-column align-items-center justify-content-center">

      <div className="logo-container">
        <Image src={logo} alt="Logo" width="159"  fluid className="logo" />
      </div>

      <div className="image-container">

        <div className="text-overlay">
          <p>¿BUSCAS Una cita? <br/>¿Cómo Llegar a una Ubicación?<br/> ¿Buscas un servicio?</p>
        </div>
        <div className="text-overlay2">
          <p>De momento permÍtenos ayudarte por estas vÍas:</p>
        </div>




        <div className="button-container">
          <button className="custom-button" onClick={openWhatsApp}>
            <Image src={wsp} alt="whatsapp" fluid className='wsp' />
            <p className="button-text">812 108 2008 </p>
          </button>

          <button className="custom-button" onClick={openTel}>
            <Image src={tel} alt="whatsapp" fluid className='tel' />
            <p className="button-text">818 218 8555 </p>
          </button>

          <button className="custom-button" onClick={openFB}>
            <Image src={fb} alt="facebook" fluid className='fb' />
          </button>

          <button className="custom-button" onClick={openInsta}>
            <Image src={inst} alt="instagram" fluid className='inst' />
          </button>

          
        </div>




        <div className="aviso-container">
          <button className="custom-button" onClick={openAviso}>           
            <p className="button-text">AVISO DE PRIVACIDAD </p>
          </button>       
        </div>



       
        <Image src="images/manos.png" fluid className="manos" />
       
      </div>
   
    </div>
  );
}

export default Proximamente;
